
    <div class="ui-dialog-content ui-g-12">
      <form [formGroup]="balanceForm" (submit)="onConfirmTransfer()">
        <div [kv-form-element]="{ label: 'common.balance', md: '12'}">
          <input pInputText formControlName="balanceTransfer" type="number" min="0" max="{{this.maxPoint}}" />
          {{'(max: ' + maxPoint + ')'}}
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4"></div>
          <div class="ui-g-4">
            <button [disabled]="!balanceForm.valid" pButton type="submit" class="buttonExpand k-generic-btn" [label]="'common.confirm' | translate" ></button>
          </div>
          <div class="ui-g-4"></div>
        </div>
      </form>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/components/point-transfer-dialog.component.ts.PointTransferDialogComponent.html